
<div
  ref="keyboardInput"
  :class="classes(n())"
>
  <div
    v-if="isShowPlaceHolder && placeholderPosition === 'left'"
    :class="classes(n('--placeholder'))"
    data-index="-1"
    @click="handleFocus"
  >
    {{ placeholder }}
  </div>
  <div
    v-for="(char, i) in chars"
    :key="i"
    :data-val="char"
    :data-index="i"
    :class="[classes(n('--item')), i === 0 ? classes(n('--begin')) : '']"
    @click="handleFocus"
  >
    <i
      :data-val="char"
      :data-index="i"
    >{{ char }}</i><i
      v-show="cursorPos === i"
      :class="[isFocus ? classes(n('--cursor')) : '']"
    />
  </div>
  <div
    v-if="isShowPlaceHolder && placeholderPosition === 'right'"
    :class="classes(n('--placeholder'))"
    data-index="-1"
    @click="handleFocus"
  >
    {{ placeholder }}
  </div>
  <Keyboard
    :visible="isShowKeyboard"
    :type="props.type"
    :decimal="props.decimal"
    :confirm-btn-text="props.confirmBtnText"
    :confirm-btn-enable="props.confirmBtnEnable"
    @input="handleInput"
    @delete="handleDelete"
    @confirm="handleConfirm"
    @blur="handleBlur"
  />
</div>
